export const oneLowerLetter = new RegExp('(?=.*?[a-z])');
export const oneUpperLetter = new RegExp('(?=.*?[A-Z])');
export const oneDigit = new RegExp('(?=.*?[0-9])');
export const specialCaracter = new RegExp('(?=.*?[#?!@$%^&*-])');
export const eightCaracters = new RegExp('.{8,}');
export const emailReggex = new RegExp(
  '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'
);
